import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'environments/environment';
import { endpoints } from 'environments/endpoints';
import { Parameter } from 'app/shared/models/parameters/parameter.model';
import { GridRequest } from 'app/shared/models/gridRequest.model';
import { HttpHeadersUtil } from 'app/shared/utils/http-headers.util';


@Injectable({
  providedIn: 'root'
})
export class ParameterService {
  private baseRoute = environment.GATEWAY_API + endpoints.parameter.baseRoute;
  private subRoutes = endpoints.parameter.subRoutes;

  constructor(private _httpClient: HttpClient) {}

  getById(id: string): Observable<Parameter> {
    return this._httpClient.get<Parameter>(
      `${this.baseRoute}${this.subRoutes.getById + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getByCodes(code: string, codeParameterType: string): Observable<Parameter> {
    return this._httpClient.get<Parameter>(
      `${this.baseRoute}${this.subRoutes.getByCodes + code + '/' + codeParameterType}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAllByType(idParameterType: string, request: GridRequest): Observable<any> {
    return this._httpClient.post<any>(
      `${this.baseRoute}${this.subRoutes.getAllByType + idParameterType}`,
      request,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAllActiveByType(idParameterType: string, id: string): Observable<Parameter[]> {
    if (id === null) id = '00000000-0000-0000-0000-000000000000';
    return this._httpClient.get<Parameter[]>(
      `${this.baseRoute}${this.subRoutes.getAllActiveByType + idParameterType + '/' + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAllActiveByCodeType(codeParameterType: string, id: string): Observable<Parameter[]> {
    if (id === null) id = '00000000-0000-0000-0000-000000000000';
    return this._httpClient.get<Parameter[]>(
      `${this.baseRoute}${this.subRoutes.getAllActiveByCodeType + encodeURIComponent(codeParameterType) + '/' + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getAllActiveByCodeParent(
    codeParameterType: string,
    idParent: string,
    id: string
  ): Observable<Parameter[]> {
    if (id === null) id = '00000000-0000-0000-0000-000000000000';
    return this._httpClient.get<Parameter[]>(
      `${this.baseRoute}${this.subRoutes.getAllActiveByCodeParent + codeParameterType + '/' + idParent + '/' + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  add(item: Parameter): Observable<Parameter> {
    return this._httpClient.post<Parameter>(
      `${this.baseRoute}${this.subRoutes.add}`,
      item,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  edit(item: Parameter): Observable<Parameter> {
    return this._httpClient.put<Parameter>(
      `${this.baseRoute}${this.subRoutes.update}`,
      item,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  getDataChanges(id: string): Observable<string> {
    return this._httpClient.get<string>(
      `${this.baseRoute}${this.subRoutes.getDataChanges + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  transformConcatToAcepFormat(comb: string): Observable<string> {
    return this._httpClient.get<string>(
      `${this.baseRoute}${this.subRoutes.transformConcatToAcepFormat + comb}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }

  diffuse(id: string): Observable<any> {
    return this._httpClient.post<Parameter>(
      `${this.baseRoute}${this.subRoutes.diffuse + id}`,
      HttpHeadersUtil.prepareDefaultHeaders()
    );
  }  

  getExportExcelUrl(idParameterType: string, title: string): string {    
    return `${this.baseRoute}${this.subRoutes.exportExcel + idParameterType + '/' + encodeURIComponent(title)}`;
  }

}
